__webpack_require__.p = "https://statics.worldid.app/admin/1.30.2/";